import { createFeatureSelector, createSelector } from '@ngrx/store';
import { WorkCenterState } from '@app/core/store/reducers/work-center';

const getWorkCenterFeatureState = createFeatureSelector<WorkCenterState>('workCenters');

export const getWorkCenters = createSelector(getWorkCenterFeatureState, (state: WorkCenterState) => state.workCenters);

export const getWorkCenterFilter = createSelector(getWorkCenterFeatureState, (state: WorkCenterState) => state.filter);

export const getFilteredWorkCenters = createSelector(getWorkCenters, getWorkCenterFilter, (workCenters, filter) => {
  if (!filter) {
    return workCenters;
  }
  const search = filter.trim().toLowerCase();
  return workCenters.filter(
    (wc) =>
      wc.id?.toLowerCase().includes(search) ||
      wc.name?.toLowerCase().includes(search) ||
      wc.number?.toLowerCase().includes(search),
  );
});
